import {
  createModule,
  action,
  mutation,
} from 'vuex-class-component';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import { CreateFileQueryDto, DownloadFileQueryDto, DownloadFileResponse, FileInfo, GetFileInfoResponse } from '@/@types/File';

const VuexModule = createModule({
  namespaced: 'theoryApiFilesStore',
  strict: false,
});

export class FilesStore extends VuexModule {
  private readonly filesRepository = RepositoryFactory.theoryApi.filesRepository();
  /** state */
  private downloadUrl: DownloadFileResponse | null = null;
  private fileInfo: FileInfo | null = null;

  @mutation
  private setDownloadUrl(payload: DownloadFileResponse) {
    this.downloadUrl = payload;
  }

  @mutation
  private setFileInfo(payload: FileInfo) {
    this.fileInfo = payload;
  }

  /** ファイルダウンロード */
  @action
  async fetchDownloadUrl(params: { fileId: number, query: DownloadFileQueryDto }) {
    const url = await this.filesRepository.downloadFile(params.fileId, params.query);
    this.setDownloadUrl(url);
  }

  /** ファイル登録 */
  @action
  async createFile(params: { query: CreateFileQueryDto, param: FormData }) {
    await this.filesRepository.createFile(params.query, params.param);
  }

  /**ファイル削除 */
  @action
  async deleteFile(params: { fileId: number, projectId: number }) {
    await this.filesRepository.deleteFile(params.fileId, params.projectId);
  }

  get getDownloadUrl() {
    return this.downloadUrl;
  }

  /** ファイル情報取得 */
  @action
  async fetchFileInfo(params: { fileId: number, projectId: number; }) {
    const GetFileInfoResponse = await this.filesRepository.getFileInfo(params);
    this.setFileInfo(GetFileInfoResponse.result[0]);
  }

  get getFileInfo() {
    return this.fileInfo;
  }
}
